document.querySelectorAll('[data-iris-cart-form]').forEach(function (form) {
  var busy = false;
  form.addEventListener('submit', async function (event) {
    if (!event.submitter || event.submitter.name !== 'update') return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    var buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    var previous = buttons.map(function (button) { return button.disabled; });
    buttons.forEach(function (button) { button.disabled = true; });
    var status = form.querySelector('[data-iris-cart-status]');
    status.hidden = true;
    var updates = {};
    form.querySelectorAll('[data-line-key]').forEach(function (input) {
      updates[input.dataset.lineKey] = Number(input.value);
    });
    try {
      var response = await fetch(form.dataset.updateUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      if (!response.ok) throw new Error('Cart update failed');
      await response.json();
      window.location.assign(form.dataset.returnUrl);
    } catch (_) {
      status.hidden = false;
      buttons.forEach(function (button, index) { button.disabled = previous[index]; });
      busy = false;
    }
  });
});
